import {readAdminRuntimeStateFromStorage} from './readAdminRuntimeStateFromStorage'

export function isGodModeEnabled(): boolean {
  return readAdminRuntimeStateFromStorage().godMode
}
